<template>
  <v-container
    pa-0
    :id="sectionId"
    class="global-typography faq-container"
    :class="{
      'pt-9 mb-9': $vuetify.breakpoint.smAndUp,
      'pt-3 mb-3': $vuetify.breakpoint.xsOnly,
    }"
  >
    <v-row>
      <v-col
        cols="12"
        v-if="
          isSitecoreExperienceEditorOn ||
            (fields.SectionTitle && fields.SectionTitle.value && fields.SectionTitle.value !== '')
        "
      >
        <sc-text :field="this.fields.SectionTitle" tag="h2" class="section-title" />
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-expansion-panels accordion focusable flat v-model="panel">
          <v-expansion-panel
            :class="{
              'mb-3': $vuetify.breakpoint.xsOnly,
              'mb-4': $vuetify.breakpoint.smAndUp,
            }"
            v-for="item in faqItems"
            :key="item.id"
            :id="'faq-' + sectionId + '-' + formatId(item.Question.value)"
            v-on:click="goToItem(sectionId, formatId(item.Question.value))"
          >
            <v-expansion-panel-header class="panel-header pa-5 bold" @click="trackAnalytics(sectionId, item)">
              <template v-slot:actions>
                <v-icon>$expand</v-icon>
              </template>
              <sc-text :field="item.Question" />
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                class="panel-content pa-6 pb-0"
                :class="{
                  'pt-4': $vuetify.breakpoint.xsOnly,
                }"
              >
                <sc-rich-text :field="item.Answer" />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Text, RichText, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'FaqItems',
  data() {
    return {
      panel: [],
      activeItem: '',
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  mounted() {
    this.$root.$on('CloseOtherFaqItems', (section) => {
      // listen to the event to close all items other than the section passed in argument
      if (section != this.sectionId) {
        this.panel = [];
      }
    });
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    sectionId() {
      return this.fields.SectionTitle.value.replace(/ /g, '-');
    },
    faqItems() {
      let list = [];
      let id = 1;
      if (this.fields.FAQListMembers) {
        this.fields.FAQListMembers.forEach((item) => {
          let question;
          if (item && item.fields && item.fields.Question && item.fields.Question.value) {
            question = item.fields.Question;
          }
          let answer;
          if (item && item.fields && item.fields.Answer && item.fields.Answer.value) {
            answer = item.fields.Answer;
          }
          if (question && answer) {
            list.push({
              id: id,
              Question: question,
              Answer: answer,
            });
            id++;
          }
        });
      }
      return list;
    },
  },
  methods: {
    formatId(text) {
      return text.toString().replace(/[\W_]+/g, '-');
    },
    goToItem(section, itemId) {
      // close other FAQ Items which are in all other sections...
      this.$root.$emit('CloseOtherFaqItems', section);

      // Scroll to item need to delay the scrolling as the accordion animation will cause issue
      setTimeout(
        () =>
          this.$vuetify.goTo('#faq-' + section + '-' + this.formatId(itemId), {
            container: document.documentElement,
            offset: 80,
          }),
        250
      );
    },
    trackAnalytics(section, item) {
      let selectedItem = section + '-' + item.id;
      if (!this.activeItem || this.activeItem != selectedItem) {
        this.$store.dispatch('analytics', {
          actionName: 'Custom-Link-Click',
          entityChange: item.Question.value,
        });
        this.activeItem = selectedItem;
      }
    },
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
};
</script>
<style lang="scss">
div.faq-container:last-of-type {
  padding-bottom: 36px !important;
}
</style>
<style lang="scss" scoped>
.v-expansion-panels {
  .v-expansion-panel {
    background-color: unset !important;
    &:last-of-type {
      padding-bottom: 0px;
      margin-bottom: 0px !important;
    }

    .panel-header {
      background: map-deep-get($colors, 'white', 'base') !important;
      background-color: map-deep-get($colors, 'white', 'base') !important;
      font-weight: map-get($font-weights, 'medium');
      font-size: 16px;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-weight: map-get($font-weights, 'normal');
        font-size: 14px;
      }
      color: map-deep-get($colors, 'blue-text', 'base');
      border-radius: 0;
      &::before {
        opacity: 0;
        background-color: map-deep-get($colors, 'white', 'base') !important;
      }
      &:hover {
        background: map-deep-get($colors, 'white', 'base') !important;
        background-color: map-deep-get($colors, 'white', 'base') !important;
      }
    }

    .v-expansion-panel-content {
      border-left: none !important;
      border-right: none !important;
      border-bottom: none !important;
      background: unset !important;
      background-color: unset !important;
      font-weight: map-get($font-weights, 'normal');
      font-size: 16px;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 14px;
      }
    }
  }
}
</style>
